export default __webpack_public_path__ + "static/22-acc87da73dd6cbcc7474c270dfa7cca1.jpg";